<template>
  <v-list-item class="export-excel" @click="clickHandler" :loading="isFetching"
    >Xuất File Excel</v-list-item
  >
</template>

<script>
import { APIRespository } from '@/plugins/api'
import { saveAs } from 'file-saver'
import XLSX from 'xlsx'
export default {
  props: {
    api: {
      type: String,
      default: ''
    },
    itemPerRequest: {
      type: Number,
      default: 100
    },
    customHeader: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      apiRepository: null,
      totalItem: 0,
      items: [],
      isFetching: false
    }
  },
  mounted() {
    this.createAPIRespository()
  },
  methods: {
    createAPIRespository() {
      if (!this.api) {
        return
      }
      this.apiRepository = APIRespository(this.api)
    },
    async clickHandler() {
      await this.getTotalItem()
      this.getItems(0, this.export)
    },
    async getTotalItem() {
      this.totalItem = await this.apiRepository.count()
    },
    getItems(start, onSuccess) {
      this.isFetching = true
      if (this.items.length === this.totalItem) {
        this.isFetching = false
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(this.items)
        }
        return
      }
      this.apiRepository
        .fetch({
          _start: start,
          _limit: this.itemPerRequest
        })
        .then(data => {
          this.items = this.items.concat(data)
          this.getItems((start += this.itemPerRequest), onSuccess)
        })
        .catch(err => {
          this.isFetching = false
          console.error(err)
        })
    },
    export(items) {
      try {
        const customHeader = this.customHeader.reduce((acc, item) => ({ ...acc, [item.value]: item.text }), {})
        const header =
          this.customHeader.length > 0
            ? this.customHeader.map(item => item.text)
            : Object.keys(items[0])
        const headerValues =
          this.customHeader.length > 0
            ? this.customHeader.map(item => item.value)
            : Object.keys(items[0])
        const collectedItems = items.map(item => {
          const newItem = {}
          headerValues.forEach(field => {
            newItem[field] = item[field]
          })
          return newItem
        })
        collectedItems.unshift(customHeader)
        const ws = XLSX.utils.json_to_sheet(collectedItems, { skipHeader: true, origin: 'A1' })
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws)
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        saveAs(blob, `export-excel.xlsx`)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style>
.export-excel {
  cursor: pointer;
}
</style>
